<template>
  <section class="entity-settings__show">
    <div class="top-info">
      <div class="top-info-logo">
        {{ $t(`entity.logo`)}}
        <img v-if="!(entity.logo)" alt="Logo entidad" src="@/assets/images/placeholder.jpg">
        <img v-else alt="Logo entidad" :src="entity.logo">
      </div>
      <div class="top-info-entity">
        <div class="entity-name"> {{ $t(`entity.businessName`)}} <span class="value"> {{ entity.businessName }} </span></div>
        <div> {{ $t(`entity.commercialAddress`)}}  <span class="value"> {{ entity.commercialAddress }} </span></div>
        <div> {{ $t(`entity.phone`)}} <span class="value"> {{ entity.phone }} </span> </div>
      </div>
    </div>
    <div class="bottom-info">
      <div class="data"> <label> {{ $t(`entity.city`)}} </label>   <span class="value"> {{ entity.city }} </span></div>
      <div class="data"> <label> {{ $t(`entity.country`)}} </label>  <span class="value"> {{ entity.country }} </span></div>
      <div class="data"> <label> {{ $t(`entity.cuit`)}} </label>  <span class="value"> {{ entity.cuit }} </span> </div>
      <div class="data"> <label> {{ $t(`entity.email`)}} </label>  <span class="value"> {{ entity.email }} </span> </div>
      <div class="data"> <label> {{ $t(`entity.incomeTaxSituation`)}} </label>  <span class="value"> {{ entity.incomeTaxSituation }} </span> </div>
      <div class="data"> <label> {{ $t(`entity.ivaSituation`)}} </label>  <span class="value"> {{ entity.ivaSituation }} </span> </div>
      <div class="data"> <label> {{ $t(`entity.state`)}} </label>  <span class="value"> {{ entity.state }} </span> </div>
      <div class="data"> <label> {{ $t(`entity.zipcode`)}} </label>  <span class="value"> {{ entity.zipcode }} </span> </div>
      <div class="data"> <label> Email de notificaciones </label>  <span class="value"> {{ entity.notificationEmails ? entity.notificationEmails[0] : '' }} </span> </div>
      <div class="data"><label>Mostrar en Ranking de Empresas</label><span class="value">{{ entity.showInRanking ? "Si" : "No" }}</span></div>
      <div v-if="entity.productionMothers" class="data">
        <label>Cantidad de Madres de Producción</label>
        <span class="value"> {{ entity.productionMothers }} </span>
      </div>
      <div v-if="entity.slaughterQuantityPerMonth" class="data">
        <label>Cantidad de animales enviados a faena por mes</label>
        <span class="value"> {{ entity.slaughterQuantityPerMonth }} </span>
      </div>
      <div v-if="entity.ruca" class="data">
        <label>Matrícula RUCA</label>
        <span class="value">{{ entity.ruca }}</span>
      </div>
      <div class="data"> <label> {{ $t(`entity.comments`)}} </label> {{ entity.comments }}</div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'show-entity',
  props: {
    entity: {
      type: Object,
      required: true
    }
  }
}
</script>
